import React from "react";
import { Alert, Snackbar } from "@mui/material";

const ServerResponesToast = ({ open, success, message, onClose }) => (
  <Snackbar open={open} autoHideDuration={3000} onClose={onClose}>
    <Alert severity={success ? "success" : "error"}>{message}</Alert>
  </Snackbar>
);

export default ServerResponesToast;
